import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { useUser } from "../utils/UserContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartSimple} from '@fortawesome/free-solid-svg-icons'
import TradingViewWidget from "../components/TradingViewWidget";
import TradeForm from "../components/TradeForm";
import { useLocation } from "react-router-dom";
import { toast } from 'react-hot-toast';
import { getCurrencySymbol } from '../utils/currencyUtils';

function Trade() {
  const { user } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");
  const tradetype = queryParams.get("tradetype");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [type, setType] = useState(tradetype?tradetype:'crypto');
  const [trade, setTrade] = useState(symbol ? symbol : type === "crypto" ? "BTC" : type === "forex" ? "AAPL" : "EUR");
  const [activeTab, setActiveTab] = useState("open")
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);  
    useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchtrade: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const openTrades = [];
        const closedTrades = [];
        data.trades.forEach(trade => {
          if (trade.details === "Running") {
            openTrades.push(trade);
          } else {
            closedTrades.push(trade);
          }
        });
        setOpenTrades(openTrades);
        setClosedTrades(closedTrades);
      }else{
        toast.error(data.message);
      }
    })
    .catch(err => {
      toast.error('Error fetching trade data!')
    })
  }, [user]);  
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Trade" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Trade" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-lg-8 col-12">
                <div className="mycard p-2 mt-2">
                  <TradingViewWidget symbol={trade} type={type} />
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <TradeForm trade={trade} setTrade={setTrade} type={type} setType={setType}/>
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{minHeight: '450px'}}>
                  <div className="d-flex align-items-center mb-4">
                    <h6 className="mb-0 text-white me-3" style={{fontSize: '18px'}}>Trades</h6>
                    <div className="mytab">
                      <div className={`mytab-item ${activeTab === "open" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("open")}}>Open</div>
                      <div className={`mytab-item ${activeTab !== "open" ? 'active' : ''}`} onClick={() => {
                        setActiveTab("closed")}}>Closed</div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {activeTab === "open" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                          <th className="fw-normal text-light" style={{width: '150px'}}>Trade ID</th>
                          <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                          <th className="fw-normal text-light">Type</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Stop Loss</th>
                          <th className="fw-normal text-light text-nowrap">Take Profit</th>
                          <th className="fw-normal text-light text-nowrap">Time Frame</th>
                          <th className="fw-normal text-light text-nowrap">Leverage</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {openTrades.length > 0 && openTrades.map((trade, index) => (
                          <tr key={index}>
                            <td>{trade.trade_id}</td>
                            <td>{trade.trade_time}</td>
                            <td>{trade.type}</td>
                            <td>{trade.pair}</td>
                            <td>{trade.action}</td>
                            <td>{type === "Buy" ? getCurrencySymbol(user?.currency):''}{trade.amount}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.entry}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.sl}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.tp}</td>
                            <td>{trade.tf}</td>
                            <td>{trade.leverage}X</td>
                            <td>{trade.result}</td>
                            <td className="text-warning">{trade.details}</td>
                          </tr>
                        ))}
                        {openTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Open trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                    {activeTab === "closed" && (
                    <table className="table table-borderless table-dark align-middle">
                      <thead>
                        <tr className="fs-7">
                        <th className="fw-normal text-light" style={{width: '150px'}}>Trade ID</th>
                          <th className="fw-normal text-light" style={{width: '150px'}}>Date</th>
                          <th className="fw-normal text-light">Type</th>
                          <th className="fw-normal text-light">Trade</th>
                          <th className="fw-normal text-light">Direction</th>
                          <th className="fw-normal text-light">Amount</th>
                          <th className="fw-normal text-light text-nowrap">Entry Price</th>
                          <th className="fw-normal text-light text-nowrap">Stop Loss</th>
                          <th className="fw-normal text-light text-nowrap">Take Profit</th>
                          <th className="fw-normal text-light text-nowrap">Time Frame</th>
                          <th className="fw-normal text-light text-nowrap">Leverage</th>
                          <th className="fw-normal text-light">Profit</th>
                          <th className="fw-normal text-light">Action</th>
                        </tr>
                      </thead>
                      <tbody style={{fontSize: '14px'}}>
                        {closedTrades.length > 0 && closedTrades.map((trade, index) => (
                          <tr key={index}>
                            <td>{trade.trade_id}</td>
                            <td>{trade.trade_time}</td>
                            <td>{trade.type}</td>
                            <td>{trade.pair}</td>
                            <td>{trade.action}</td>
                            <td>{type === "Buy" ? getCurrencySymbol(user?.currency):''}{trade.amount}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.entry}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.sl}</td>
                            <td>{getCurrencySymbol(user?.currency)}{trade.tp}</td>
                            <td>{trade.tf}</td>
                            <td>{trade.leverage}X</td>
                            <td>{trade.result}</td>
                            <td className={`${trade.details === 'Loss' ? 'text-danger' : 'text-success'}`}>{trade.details}</td>
                          </tr>
                        ))}
                        {closedTrades.length === 0 && (
                          <tr>
                            <td colSpan={5}>No Closed trades yet.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Trade